(function () {
  const OPTION_NAMES = ['geschmack', 'flavour', 'flavor', 'taste'];
  const MIN_VALUES = 3; // ab 3 Werten -> Dropdown (du kannst auch 4 nehmen)

  function normalize(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function findOptionWrappers(root) {
    // In deinem DOM sieht es so aus: .product-variant[data-name="product-geschmack-..."]
    return Array.from(root.querySelectorAll('.product-variant[data-name]'));
  }

  function isTasteOption(wrapper) {
    const dataName = normalize(wrapper.getAttribute('data-name'));
    return OPTION_NAMES.some(n => dataName.includes(n));
  }

  function hasDropdownAlready(wrapper) {
    return !!wrapper.parentElement.querySelector('.maw-geschmack-dropdown');
  }

  function buildDropdownFromRadios(wrapper) {
    const radios = wrapper.querySelectorAll('input[type="radio"]');
    if (!radios || radios.length < MIN_VALUES) return;

    // nicht doppelt bauen
    if (hasDropdownAlready(wrapper)) return;

    const select = document.createElement('select');
    select.className = 'maw-geschmack-dropdown';

    radios.forEach(radio => {
      const label = wrapper.querySelector(`label[for="${radio.id}"]`);
      if (!label) return;

      const opt = document.createElement('option');
      opt.value = radio.id;
      opt.textContent = label.textContent.trim();
      if (radio.checked) opt.selected = true;
      select.appendChild(opt);
    });

    // UI verstecken (aber im DOM lassen, damit Shopify-Logik bleibt)
    // Nur den Inhalt (Radio-Buttons) verstecken, nicht die Überschrift
const container = wrapper.querySelector('[data-js-product-variant-container]') || wrapper;
container.style.display = 'none';


    // Dropdown direkt danach einfügen
    wrapper.insertAdjacentElement('afterend', select);

    // Dropdown -> Radio click (Shopify reagiert sauber)
    select.addEventListener('change', () => {
      const r = document.getElementById(select.value);
      if (r) r.click();
    });

    // Radio -> Dropdown sync (wenn Shopify aus irgendeinem Grund radio ändert)
    wrapper.addEventListener('change', () => {
      const checked = wrapper.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      select.value = checked.id;
    });
  }

  function run(root = document) {
    const wrappers = findOptionWrappers(root);
    wrappers.forEach(w => {
      if (!isTasteOption(w)) return;
      buildDropdownFromRadios(w);
    });
  }

  // initial
  document.addEventListener('DOMContentLoaded', () => run(document));

  // Wenn Shopify Sections neu lädt (Theme Editor & teils Variant-Rerender)
  document.addEventListener('shopify:section:load', (e) => run(e.target));

  // Fallback: wenn Theme via JS den Picker neu rendert (MutationObserver)
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.querySelector?.('.product-variant[data-name]')) {
          run(node);
        }
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
